import { toNavItemData } from "@/contents/converters/atoms"
import { Footer as FooterSanity, NavItem } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityTextField from "@/integrations/sanity/components/SanityTextField"
import Footer from "@/ui/layout/Footer"
import { NavItemData } from "@/ui/types/nav"

export interface SanityFooterProps {
  content: FooterSanity
}

const SanityFooter = ({ content }: SanityFooterProps) => {
  return (
    <Footer
      company={{
        logo: <SanityImageField asset={content.logoNegative} width={280} />,
        address: content.companyAddress,
        email: content.companyEmail,
      }}
      links={{
        copyright: (
          <SanityTextField
            value={content.copyright}
            placeholders={{
              year: new Date().getFullYear().toString(),
            }}
          />
        ),
        level1links: content.level1Links?.map((link: NavItem) =>
          toNavItemData(link)
        ) as NavItemData[],
        level2links: content.level2Links?.map((link: NavItem) =>
          toNavItemData(link)
        ) as NavItemData[],
        socialLinks: content.socialLinks?.map((x) => ({
          logo: <SanityImageField asset={x.logo} height={60} fill="height" />,
          link: {
            type: "external",
            url: x.link,
          },
        })),
      }}
    />
  )
}

export default SanityFooter
